
import { mapGetters } from 'vuex';

export default {
  name: 'AppVideoPlayIcon',
  props: {
    duration: { type: Number, default: null },
    showDuration: { type: Boolean, default: true },
    size: {
      type: String,
      default: null,
      validator: v => v === null || v === 'responsive'
    },
    iconSize: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters('widget', ['isMobileViewport']),
    resolvedIconSize() {
      if (this.iconSize) return this.iconSize;
      if (this.size === 'responsive') return this.isMobileViewport ? 20 : 24;
      return null;
    },
    responsiveIconName() {
      if (this.resolvedIconSize === 20) return 'ic-play-20px';
      if (this.resolvedIconSize === 24) return 'ic-play-24px';
      return null;
    },
    formattedDuration() {
      const minutes = parseInt(this.duration / 60).toString();
      const seconds = String(this.duration % 60).padStart(2, '0');
      return minutes + ':' + seconds;
    }
  }
};
